import {
  CashFlowNature,
  TransactionBankOperationCategory,
  TransactionCategory,
  TransactionCreditCategory,
  TransactionExpenseCategory,
  TransactionIncomeCategory,
  TransactionRefundCategory,
  TransactionSavingCategory,
  TransactionTaxCategory,
  TransactionType,
} from '@algoan/dashboard/model';

export const transactionCategoryToCashFlowNature: Record<TransactionCategory, CashFlowNature> = {
  [TransactionIncomeCategory.DISSAVING]: 'incomes',
  [TransactionIncomeCategory.OTHER_ENTRY]: 'incomes',
  [TransactionCreditCategory.LOAN_DRAWDOWN]: 'incomes',
  [TransactionCreditCategory.LOAN_DRAWDOWN_REAL_ESTATE]: 'incomes',
  [TransactionCreditCategory.LOAN_DRAWDOWN_PERSONAL]: 'incomes',
  [TransactionCreditCategory.LOAN_DRAWDOWN_REVOLVING]: 'incomes',
  [TransactionCreditCategory.LOAN_DRAWDOWN_FAST]: 'incomes',
  [TransactionCreditCategory.LOAN_DRAWDOWN_STUDENT]: 'incomes',
  [TransactionIncomeCategory.GAMBLING_GAIN]: 'incomes',
  [TransactionTaxCategory.PERSO_TAX_CREDIT]: 'incomes',
  [TransactionTaxCategory.PERSO_TAX_REFUND]: 'incomes',
  [TransactionBankOperationCategory.REFUND_DIRECT_DEBT_RECOVERY_FEES]: 'incomes',
  [TransactionBankOperationCategory.REFUND_ACCOUNT_SEIZURE_FEES]: 'incomes',
  [TransactionBankOperationCategory.REFUND_PREVENTIVE_SEIZURE_FEES]: 'incomes',
  [TransactionBankOperationCategory.RELEASE_DIRECT_DEBT_RECOVERY]: 'incomes',
  [TransactionBankOperationCategory.RELEASE_ACCOUNT_SEIZURE]: 'incomes',
  [TransactionBankOperationCategory.RELEASE_PREVENTIVE_SEIZURE]: 'incomes',
  [TransactionRefundCategory.REFUND]: 'incomes',
  [TransactionRefundCategory.REFUND_INSURANCE]: 'incomes',
  [TransactionRefundCategory.REFUND_EXPENSE_REPORT]: 'incomes',
  [TransactionBankOperationCategory.REFUND_BANK_SERVICE_FEES]: 'incomes',
  [TransactionTaxCategory.PRO_TAX_REFUND]: 'incomes',
  [TransactionBankOperationCategory.REFUND_BANK_INCIDENT_FEES]: 'incomes',
  [TransactionSavingCategory.INTEREST]: 'incomes',
  [TransactionBankOperationCategory.CREDIT_CARD_RESET]: 'incomes',
  [TransactionIncomeCategory.ALLOWANCE_FAMILY]: 'resources',
  [TransactionIncomeCategory.ALLOWANCE]: 'resources',
  [TransactionIncomeCategory.ALLOWANCE_HOUSING]: 'resources',
  [TransactionIncomeCategory.ALLOWANCE_UNEMPLOYMENT]: 'resources',
  [TransactionIncomeCategory.ALLOWANCE_INCOME_SUPPORT]: 'resources',
  [TransactionIncomeCategory.ALLOWANCE_HEALTH]: 'resources',
  [TransactionIncomeCategory.ALLOWANCE_DISABILITY]: 'resources',
  [TransactionIncomeCategory.STATE_SUBSIDY]: 'resources',
  [TransactionIncomeCategory.RENTAL_INCOME]: 'resources',
  [TransactionIncomeCategory.RECEIVED_ALIMONY]: 'resources',
  [TransactionIncomeCategory.WAGE]: 'resources',
  [TransactionIncomeCategory.WAGE_BONUS]: 'resources',
  [TransactionIncomeCategory.WAGE_SALARY_ADVANCE]: 'resources',
  [TransactionIncomeCategory.WAGE_ADVANCE_PAYMENT]: 'resources',
  [TransactionIncomeCategory.FREELANCE]: 'resources',
  [TransactionIncomeCategory.RETIREMENT_PENSION]: 'resources',
  [TransactionIncomeCategory.REVERSIONARY_PENSION]: 'resources',
  [TransactionIncomeCategory.REGULAR_INCOME]: 'resources',
  [TransactionExpenseCategory.DEFERRED_TOTAL_PAYMENT]: 'expenses',
  [TransactionExpenseCategory.GROCERY]: 'expenses',
  [TransactionExpenseCategory.PAID_ALIMONY]: 'expenses',
  [TransactionExpenseCategory.LEISURE]: 'expenses',
  [TransactionExpenseCategory.SHOPPING]: 'expenses',
  [TransactionExpenseCategory.TOBACCO]: 'expenses',
  [TransactionExpenseCategory.GAMBLING]: 'expenses',
  [TransactionExpenseCategory.MULTIMEDIA]: 'expenses',
  [TransactionExpenseCategory.SPORT]: 'expenses',
  [TransactionExpenseCategory.ATM]: 'expenses',
  [TransactionExpenseCategory.CARD_PAYMENT]: 'expenses',
  [TransactionExpenseCategory.CHECK]: 'expenses',
  [TransactionTaxCategory.PRO_TAX]: 'expenses',
  [TransactionTaxCategory.PERSO_TAX]: 'expenses',
  [TransactionTaxCategory.INCOME_TAX]: 'expenses',
  [TransactionTaxCategory.HOUSING_TAX]: 'expenses',
  [TransactionTaxCategory.PROPERTY_TAX]: 'expenses',
  [TransactionExpenseCategory.HEALTH]: 'expenses',
  [TransactionBankOperationCategory.FEES_BANK_SERVICE]: 'expenses',
  [TransactionBankOperationCategory.FEES_INCIDENT]: 'expenses',
  [TransactionBankOperationCategory.FEES_OVERDRAFT]: 'expenses',
  [TransactionBankOperationCategory.FEES_UNAUTHORIZED_OVERDRAFT]: 'expenses',
  [TransactionBankOperationCategory.FEES_CHECK_REJECTION]: 'expenses',
  [TransactionBankOperationCategory.FEES_INTERVENTION]: 'expenses',
  [TransactionBankOperationCategory.FEES_PAYMENT_REJECTION]: 'expenses',
  [TransactionBankOperationCategory.FEES_DIRECT_DEBT_RECOVERY]: 'expenses',
  [TransactionBankOperationCategory.FEES_ACCOUNT_SEIZURE]: 'expenses',
  [TransactionBankOperationCategory.FEES_PREVENTIVE_SEIZURE]: 'expenses',
  [TransactionBankOperationCategory.PROVISION_DIRECT_DEBT_RECOVERY]: 'expenses',
  [TransactionBankOperationCategory.PROVISION_ACCOUNT_SEIZURE]: 'expenses',
  [TransactionBankOperationCategory.PROVISION_PREVENTIVE_SEIZURE]: 'expenses',
  [TransactionExpenseCategory.OTHER_EXPENSE]: 'expenses',
  [TransactionExpenseCategory.INSURANCE]: 'fixedCharges',
  [TransactionExpenseCategory.INSURANCE_HEALTH]: 'fixedCharges',
  [TransactionExpenseCategory.INSURANCE_AUTO]: 'fixedCharges',
  [TransactionExpenseCategory.INSURANCE_HOME]: 'fixedCharges',
  [TransactionExpenseCategory.INSURANCE_LOAN]: 'fixedCharges',
  [TransactionExpenseCategory.TRANSPORT]: 'fixedCharges',
  [TransactionExpenseCategory.RENT]: 'fixedCharges',
  [TransactionExpenseCategory.POWER]: 'fixedCharges',
  [TransactionExpenseCategory.TELECOM]: 'fixedCharges',
  [TransactionExpenseCategory.REGULAR_EXPENSE]: 'fixedCharges',
  [TransactionCreditCategory.LOAN_REPAYMENT]: 'loans',
  [TransactionCreditCategory.LOAN_REPAYMENT_REAL_ESTATE]: 'loans',
  [TransactionCreditCategory.LOAN_PREPAYMENT]: 'loans',
  [TransactionCreditCategory.LOAN_REPAYMENT_PERSONAL]: 'loans',
  [TransactionCreditCategory.LOAN_REPAYMENT_REVOLVING]: 'loans',
  [TransactionCreditCategory.LOAN_REPAYMENT_FAST]: 'loans',
  [TransactionCreditCategory.LOAN_REPAYMENT_STUDENT]: 'loans',
  [TransactionCreditCategory.SPLIT_PAYMENT]: 'loans',
  [TransactionCreditCategory.DEBT_COLLECTION]: 'loans',
  [TransactionCreditCategory.BAILIFF]: 'loans',
  [TransactionCreditCategory.LEASING]: 'loans',
  [TransactionSavingCategory.SAVING]: 'expenses',
  [TransactionSavingCategory.BANKBOOK_SAVING]: 'expenses',
  [TransactionSavingCategory.SHARE_SAVING]: 'expenses',
  [TransactionBankOperationCategory.REJECTION_CHECK]: 'incomes',
  [TransactionBankOperationCategory.REJECTION_LOAN_REPAYMENT]: 'incomes',
  [TransactionBankOperationCategory.REJECTION_PAYMENT]: 'incomes',
};

export const transactionTypeToCashFlowNature: Record<TransactionType, CashFlowNature> = {
  [TransactionType.CASH_DEPOSIT]: 'incomes',
  [TransactionType.CASH_WITHDRAWAL]: 'expenses',
  [TransactionType.CHECK_DEPOSIT]: 'incomes',
  [TransactionType.CHECK]: 'expenses',
  [TransactionType.INCOMING_TRANSFER]: 'incomes',
  [TransactionType.INCOMING_INTERNAL_TRANSFER]: 'incomes',
  [TransactionType.OUTGOING_TRANSFER]: 'expenses',
  [TransactionType.OUTGOING_INTERNAL_TRANSFER]: 'expenses',
  [TransactionType.CARD]: 'expenses',
  [TransactionType.CARD_REFUND]: 'incomes',
  [TransactionType.DIRECT_DEBIT]: 'expenses',
  [TransactionType.INCOMING_CARD]: 'incomes',
  [TransactionType.CREDIT]: 'incomes',
  [TransactionType.DEBIT]: 'expenses',
};
